import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appSliderTitle]',
})
export class SliderTitleDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
